import spaceAdminUrl from './spaceAdminUrl';



export default spaceAdminUrl(({ logId = ':logId' }) => `/settings/logs/${logId}`);
